<template>
  <div
    v-if="highlights"
    id="scrollHorizontal"
    class="max-w-7xl mx-auto font-semibold py-20"
  >
      <div class="mx-6 md:mx-14">
    <carousel
      :items-to-show="1"
      :wrap-around="true"
    >
      <slide
        v-for="(trip, index) in days"
        :key="trip"
        class=""
      >
        <div
          class="w-full bg-white mt-10 flex flex-col xxs:mt-14 xs:mt-18 sm:mt-32 md:flex-row"
        >
          <figure class="relative h-80 sm:mb-5 md:w-1/2 md:h-96 md:mb-16">
            <img
              class="w-full h-full rounded-md object-fit md:object-cover md:w-full"
              :src="trip[0].image[0] ? trip[0].image[0].original_url : ''"
              :alt="trip[0].image[0] ? trip[0].image[0].name : ''"
            >
          </figure>
          <div
            class="h-full mx-6 mt-16 flex flex-col md:justify-center md:w-1/2 md:mt-0 md:mx-14"
          >
            <h1 class="text-3xl mb-4 text-left lg:text-4xl">
              Høydepunkter dag  {{ index+1 }}/{{ days.length }}
            </h1>
            <li>
              <div v-for="d in trip" class="mt-2 flex flex-row text-xl items-center">
                <svg
                  width="20"
                  height="20"
                  class="mr-5"
                  viewBox="0 0 30 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.049 1.92664C14.3483 1.00538 15.6517 1.00538 15.951 1.92664L18.368 9.36437C18.5019 9.77636 18.8858 10.0553 19.319 10.0553L27.1396 10.0556C28.1083 10.0556 28.5111 11.2952 27.7274 11.8646L21.4006 16.4617C21.0501 16.7163 20.9035 17.1676 21.0373 17.5796L23.4537 25.0176C23.753 25.9388 22.6986 26.7049 21.9149 26.1356L15.5878 21.539C15.2373 21.2844 14.7627 21.2844 14.4122 21.539L8.08508 26.1356C7.30138 26.7049 6.24695 25.9388 6.54626 25.0176L8.96267 17.5796C9.09652 17.1676 8.94987 16.7163 8.59942 16.4617L2.27261 11.8646C1.48894 11.2952 1.8917 10.0556 2.86038 10.0556L10.681 10.0553C11.1142 10.0553 11.4981 9.77636 11.632 9.36437L14.049 1.92664Z"
                    fill=""
                    stroke="#01798A"
                    stroke-width="3"
                  />
                </svg>
                {{ d.highlights }}
              </div>
            </li>
            <div class="text-left mt-10">
              <button @click="scrollToProgram" class="text-2xl border border-black rounded-md p-2 py-5 w-full md:py-2 md:w-52 md:text-lg font-semibold">
                Se hele programmet
              </button>
            </div>
          </div>
        </div>
      </slide>

      <template #addons>
        <pagination />
      </template>
    </carousel>
      </div>
  </div>
</template>

<script setup>
import 'vue3-carousel/dist/carousel.css';
import {
  Carousel, Slide, Pagination, Navigation,
} from 'vue3-carousel';

const props = defineProps({
  destinationId: {
    type: String
  },
  highlights: {
    type: Object
  },
});

const destination = props.highlights.filter(entry => entry.destination_id === props.destinationId )

const lookup = destination.reduce((acc, item) => {
  const exists = acc.some(i => i === item.start)
  return exists ? acc : [...acc, item.start];
}, []);

const grouped = destination.reduce((acc, item) => {
  const date = new Date(item.start).toLocaleTimeString([], { day: '2-digit', month: '2-digit', year: '2-digit' })
  const group = date.split(',')[0]

  if (!acc[group]) {
    acc[group] = [];
  }
  acc[group].push(item);
  return acc;
}, {});

const days = Object.values(grouped).map((array) =>
  array.map((o) => ({
    highlights: o.name,
    image: o.media
  }))
)

function scrollToProgram() {
    const target = document.getElementById('program');
    target.scrollIntoView({behavior: 'smooth'});
}

</script>


